import React, { useState } from 'react';
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  Modal,
  Grid,
  Link,
  CircularProgress,
} from '@mui/material';
import { toast } from 'react-toastify';
import { auth } from '../services/api/auth';
import service from '../services';
import { useUser } from '../Context/UserProvider';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const SignIn = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [verificationCode, setVerificationCode] = useState(Array(6).fill(''));
  const [openModal, setOpenModal] = useState(false);
  const { setUser } = useUser();
  const navigate = useNavigate()

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };


  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true)

    try {
      const formData = new FormData();
      formData.append('username', credentials.username);
      formData.append('password', credentials.password);

      const response = await auth.signIn(formData);

      if (response.data?.requires_email_verification) {
        setOpenModal(true);
        toast.info(response.data?.message);
      } else {
        service.setTokensLocalStorage(response.data?.token);
        api.profile
          .userProfile()
          .then((res) => {
            setUser(res?.data);
            toast.success("Logged in Successfully");
            navigate("/dashboard");
          })
          .catch((res) => console.log(res));
      }
    } catch (err) {
      setError(err?.response?.data?.message || 'Something went wrong');
    } finally {
      setIsLoading(false)
    }
  };


  const handleCodeChange = (e, idx) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) return;

    const newCode = [...verificationCode];
    newCode[idx] = value.slice(-1);
    setVerificationCode(newCode);
  };

  const handleVerifyCode = () => {
    setIsVerifying(true)
    const fullCode = verificationCode.join('');
    const formData = new FormData()
    formData.append('username', credentials.username)
    formData.append('code', fullCode)
    if (fullCode.length < 6) {
      return toast.warn('Enter all 6 digits');
    }
    auth.verifySignIn(formData).then(res => {
      service.setTokensLocalStorage(res.data?.token);
      toast.success(res.data?.message);
      api.profile
        .userProfile()
        .then((res) => {
          setUser(res?.data);
          toast.success("Logged in Successfully");
          navigate("/dashboard");
        })
        .catch((res) => console.log(res));
    }).catch(err => console.log(err))
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 6 }}>
        <Typography variant="h4" align="center" gutterBottom>
          Login
        </Typography>

        <form onSubmit={handleLogin}>
          <TextField
            fullWidth
            label="Username"
            name="username"
            margin="normal"
            value={credentials.username}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            name="password"
            margin="normal"
            value={credentials.password}
            onChange={handleChange}
          />

          {error && (
            <Typography color="error" variant="body2">
              {error}
            </Typography>
          )}

          <Button type="submit" disabled={isLoading === true} fullWidth variant="contained" sx={{ mt: 2 }}>
            {isLoading ? <CircularProgress /> : 'Login'}
          </Button>
          <Grid item xs={12}>
            <Typography align="center" variant="body2">
              Don't have an account?{' '}
              <Link href="/auth/register" underline="hover">
                Register
              </Link>
            </Typography>
          </Grid>
        </form>
      </Box>

      {/* Verification Modal */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            p: 4,
            borderRadius: 2,
            boxShadow: 24,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Enter Verification Code
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            A 6-digit code has been sent to your email.
          </Typography>

          <Grid container spacing={1} justifyContent="center" sx={{ mb: 2 }}>
            {verificationCode.map((digit, idx) => (
              <Grid item key={idx}>
                <TextField
                  value={digit}
                  onChange={(e) => handleCodeChange(e, idx)}
                  inputProps={{ maxLength: 1, style: { textAlign: 'center' } }}
                  sx={{ width: 40 }}
                />
              </Grid>
            ))}
          </Grid>

          <Button fullWidth disabled={isVerifying === true} variant="contained" onClick={handleVerifyCode}>
            {isVerifying ? <CircularProgress /> : 'Verify'}
          </Button>
        </Box>
      </Modal>
    </Container>
  );
};

export default SignIn;
